import { inject, Injectable } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { ActivatedRouteSnapshot, PRIMARY_OUTLET, RouterStateSnapshot, TitleStrategy } from "@angular/router";
import { configurationToken, Configuration } from "../../../configuration";
import { Strings } from "../../../strings/strings";

export type PageTitle = string | ((route: ActivatedRouteSnapshot) => string);

@Injectable()
export class PageTitleService extends TitleStrategy {
    private readonly title = inject(Title);
    private readonly configuration = inject<Configuration>(configurationToken);

    override updateTitle(routerStateSnapshot: RouterStateSnapshot): void {
        const route = this.getDeepestPrimaryRoute(routerStateSnapshot.root);
        const pageTitle = route.data["pageTitle"] as PageTitle | undefined;
        const resolvedPageTitle = typeof pageTitle === "function" ? pageTitle(route) : pageTitle || "";

        const appTitleSuffix = this.configuration.appTitleSuffix ? ` - ${this.configuration.appTitleSuffix}` : "";
        this.title.setTitle(`${resolvedPageTitle} | ${Strings.appLongName}${appTitleSuffix}`);
    }

    private getDeepestPrimaryRoute(route: ActivatedRouteSnapshot): ActivatedRouteSnapshot {
        const primaryChildRoute = route.children.find((child) => child.outlet === PRIMARY_OUTLET);
        return primaryChildRoute ? this.getDeepestPrimaryRoute(primaryChildRoute) : route;
    }
}
